var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon14Setting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7654 17.3202C19.9012 16.6502 18.5235 16.601 17.5556 17.5665C16.6667 18.4532 16.6173 19.8325 17.358 20.7685C16.4691 21.3103 15.4815 21.7044 14.4444 22C14.2469 20.8177 13.2099 19.8818 11.9753 19.8818C10.7407 19.8818 9.7037 20.8177 9.55556 22C8.51852 21.7537 7.53086 21.3103 6.64198 20.7685C7.38272 19.7833 7.28395 18.4532 6.44444 17.5665C5.48642 16.6108 4.11852 16.6355 3.23457 17.3202C2.69136 16.4335 2.2963 15.4483 2 14.4138C3.18519 14.266 4.12346 13.2315 4.12346 12C4.12346 10.7685 3.18519 9.73399 2 9.58621C2.24691 8.55172 2.69136 7.5665 3.23457 6.6798C4.09877 7.34975 5.47161 7.39902 6.44444 6.4335C7.33333 5.5468 7.38272 4.16749 6.64198 3.23153C7.53086 2.68966 8.51852 2.29557 9.55556 2C9.7037 3.18227 10.7407 4.11823 11.9753 4.11823C13.2099 4.11823 14.2469 3.18227 14.3951 2C15.4321 2.24631 16.4198 2.68966 17.3086 3.23153C16.5679 4.21675 16.6667 5.5468 17.5062 6.4335C18.4691 7.39409 19.8321 7.36453 20.7161 6.6798C21.2593 7.5665 21.6543 8.55172 21.9506 9.58621C20.8148 9.73399 19.8765 10.7685 19.8765 12C19.8765 13.2315 20.8148 14.266 22 14.4138C21.7531 15.4483 21.3086 16.4335 20.7654 17.3202Z",
    stroke: "#46B476",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14Setting);
export default __webpack_public_path__ + "static/media/icon14_setting.b6ff9cfbe681894d0c3f4dcd6b71b034.svg";
export { ForwardRef as ReactComponent };